import styled from 'styled-components';

export const Container = styled.div`
  img {
    height: 32px;
    max-width: 180px;
    margin-right: 5px;
  }  
`;
